//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const ProductDetailsFieldLabels = {
  brand: 'Product Brand',
  category: 'Product Category',
  description: 'Product Description',
  destinationGTIN: 'GTINs/UPCs/EANs for Syndication (optional)',
  imgUrl: 'Image',
  logisticsRef: 'Unique Product Code',
  name: 'Product Name',
  pdpUrl: 'Product URL (optional)',
  shippingAvailabilityDate: 'Shipping Availability Date',
  targetCatalogProductId: 'Product ID',
  fairMarketValue: 'Fair Market Value',
  quantity: 'Quantity',
  variantName: 'Name',
} as const;
